module.exports = __webpack_public_path__ + "static/media/icon-grandparents.4a779f16.svg";